export function GenerateUID(prefix = '', suffix = Date.now().toString(), randomLength = 4) {
    return prefix + Math.round(Math.random() * 10 ** randomLength) + suffix;
}
